import classNames from 'classnames';
import { useCallback, useEffect } from 'react';
import { Button } from 'yoso';
import { useFlag } from '~/components/Flag';
import { t } from '~/components/I18n';
import { Info } from '~/components/Icon';
import { DumbTooltip } from '~/components/Tooltip/Dumb/DumbTooltip';
import styles from './AdventureTooltip.module.scss';

export type AdventureTooltipProps = {
  className?: string;
};

export const AdventureTooltip = ({ className }: AdventureTooltipProps) => {
  const { hidden, setValue, hide } = useFlag({ name: 'ADVENTURE_TOOLTIP' });
  const onClick = useCallback(() => {
    setValue(!hidden);
  }, [hidden, setValue]);
  useEffect(() => () => hide(), [hide]);
  return (
    <DumbTooltip
      className={classNames(styles.root, className)}
      active={!hidden}
      onClick={onClick}
      variant="secondary"
      direction="bottom"
      tooltipText={t('citizen_adventure_participatenum_tooltip')}>
      <Button className={styles.button} variant="text">
        <Info className={styles.icon} />
      </Button>
    </DumbTooltip>
  );
};
